import makeList from './makeList.js'

let viewFloor = '発電棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '発電棟２階廊下',
        file: './data/I13f_2.JPG',
        rotation: -8.877353032468307,
        link: [
          {
            file: './data/10_R0010762.JPG',
            position: [ 4752.849420135767, 651.2328327343208, -1376.445163189514 ],
          },
          {
            file: './data/I13l.JPG',
            position: [ -4773.118705637238, 1205.9283889036642, 830.5894078385038 ],
          },
          {
            file: './data/I13a.JPG',
            position: [ -4695.278586688041, 567.5261768849507, 1600.6559790197052 ],
          },
          {
            file: './data/I13h.JPG',
            position: [ 4317.322416520269, 1042.0120306932965, -2276.031753138135 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 512.8205128205128, 200.1794871794873 ],
        },
      },
      { description: '洗面所',
        file: './data/I13l.JPG',
        rotation: -127.48598276258927,
        link: [
          {
            file: './data/I13f_2.JPG',
            position: [ 2426.1885225986243, 953.4474318430969, 4260.558224169829 ],
          },
          {
            file: './data/I13k.png',
            position: [ -2829.153885948311, 1091.7256230644664, 3969.754637748314 ],
          },
          {
            file: './data/I13j.JPG',
            position: [ 137.1623915931656, 1347.2987755001154, 4803.875727162906 ],
          },
          {
            file: './data/I13g.JPG',
            position: [ 4459.8863975906615, 1478.6876583707221, 1684.8698481349152 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 615.3846153846155, 184.79487179487194 ],
        },
      },
      { description: '野菜栽培室',
        file: './data/I13h.JPG',
        rotation: -69.85589760338843,
        link: [
          {
            file: './data/I13f_2.JPG',
            position: [ 2025.0134998455815, -418.68596966242046, 4551.226829811619 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 502.5641025641026, 125.82051282051293 ],
        },
      },
      { description: '発電棟２階廊下(奥)',
        file: './data/I13a.JPG',
        rotation: -101.44066669563969,
        link: [
          {
            file: './data/I13f_2.JPG',
            position: [ 4509.008018809958, -299.24666572650824, -2123.06368770086 ],
          },
          {
            file: './data/I13b_1.JPG',
            position: [ 4876.794797637116, -973.4547486736243, 450.2829472453134 ],
          },
          {
            file: './data/I13m.JPG',
            position: [ 4884.274653274939, -468.2795740719791, 924.5623644660949 ],
          },
          {
            file: './data/I59b_A.JPG',
            position: [ -3143.273995848603, -246.86984186304562, 3867.1435113426433 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 661.5384615384615, 295.0512820512822 ],
        },
      },
      { description: '部品工作室',
        file: './data/I13b_1.JPG',
        rotation: 89.56882545204627,
        link: [
          {
            file: './data/I13a.JPG',
            position: [ 2437.285814178623, 1323.4753579507212, 4153.882896892549 ],
          },
          {
            file: './data/I13e_1.JPG',
            position: [ 4085.844567759071, 259.0812046320768, -2857.4974599176367 ],
          },
          {
            file: './data/I13c_1.JPG',
            position: [ 1429.9321296628482, 902.955916802844, -4697.656413370276 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 553.8461538461539, 346.3333333333335 ],
        },
      },
      { description: '発電機',
        file: './data/I13e_1.JPG',
        rotation: -94.60759983180006,
        link: [
          {
            file: './data/I13b_1.JPG',
            position: [ -3538.3918005187174, -195.94311900530647, 3512.1128394478733 ],
          },
          {
            file: './data/I13c_1.JPG',
            position: [ -4082.9852297014827, -274.39124566784193, -2860.797495415876 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 384.61538461538464, 300.1794871794873 ],
        },
      },
      { description: '造水装置室(手前)',
        file: './data/I13c_1.JPG',
        rotation: 288.43733825053755,
        link: [
          {
            file: './data/I13b_1.JPG',
            position: [ 4913.841828591843, 768.0564678851249, -501.2690944512613 ],
          },
          {
            file: './data/I13e_1.JPG',
            position: [ 3128.196997526934, 447.9955974250991, -3863.5390089154207 ],
          },
          {
            file: './data/I13d_1.JPG',
            position: [ -2860.6122643924023, 336.7992220482415, -4080.1858109017653 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 471.7948717948718, 289.92307692307713 ],
        },
      },
      { description: '造水装置室(奥)',
        file: './data/I13d_1.JPG',
        rotation: -77.03536162275448,
        link: [
          {
            file: './data/I13c_1.JPG',
            position: [ 3090.2362010219863, -18.43013762200806, 3921.626114698822 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 500.00000000000006, 238.64102564102575 ],
        },
      },
      { description: '制御室',
        file: './data/I13m.JPG',
        rotation: -30.89960196854649,
        link: [
          {
            file: './data/I13a.JPG',
            position: [ -4765.005578251992, 1177.0803721460097, -933.7513733068627 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 589.7435897435898, 307.8717948717949 ],
        },
      },
      { description: '脱衣所',
        file: './data/I13k.png',
        rotation: -162.20867110728096,
        link: [
          {
            file: './data/I13a.JPG',
            position: [ 4682.924897467262, 1576.238983226081, 716.0670998614111 ],
          },
          {
            file: './data/I13i.JPG',
            position: [ -2063.8897080512315, 1695.810194573709, 4215.738041717861 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 651.2820512820514, 215.56410256410265 ],
        },
      },
      { description: '浴室',
        file: './data/I13i.JPG',
        rotation: -95.73439747644824,
        link: [
          {
            file: './data/I13k.png',
            position: [ 4829.0725162328245, 50.59677378651741, 1262.026532993933 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 705.1282051282052, 254.0256410256411 ],
        },
      },
      { description: '理髪室',
        file: './data/I13j.JPG',
        rotation: 67.13084439116994,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 625.6410256410257, 246.33333333333348 ],
        },
      },
      { description: 'トイレ',
        file: './data/I13g.JPG',
        rotation: -2.7877813013735233,
        link: [
          {
            file: './data/I13l.JPG',
            position: [ 1768.81705480469, -414.0933613762127, -4650.152838841163 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 518.9309576837417, 385.30066815144767 ],
          syowaZoom: [ 553.8461538461539, 151.46153846153857 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
